/* ===== Logger Utility ===== */
/* Centralized logging with production mode support + Firebase Crashlytics integration */

const isDevelopment = window.location.hostname === 'localhost' || 
                      window.location.hostname === '127.0.0.1' ||
                      window.location.hostname.includes('localhost');

// ✅ Lazy load Crashlytics (only when needed)
const getCrashlytics = () => {
  try {
    if (typeof firebase !== 'undefined' && firebase.crashlytics) {
      return firebase.crashlytics();
    }
  } catch (err) {
    // Crashlytics not available or failed to initialize
  }
  return null;
};

export const logger = {
  log: (...args) => {
    if (isDevelopment) {
      console.log(...args);
    }
  },
  
  error: (...args) => {
    // Always log errors, even in production
    console.error(...args);
    
    // ✅ Send to Crashlytics in production (non-blocking)
    if (!isDevelopment) {
      try {
        const crashlytics = getCrashlytics();
        if (crashlytics) {
          // Log error with context
          const errorMessage = args.map(arg => {
            if (arg instanceof Error) {
              return `${arg.message}\n${arg.stack || ''}`;
            }
            return typeof arg === 'object' ? JSON.stringify(arg) : String(arg);
          }).join(' ');
          
          // Log error message
          crashlytics.log(errorMessage);
          
          // If it's an Error object, record it
          if (args[0] instanceof Error) {
            crashlytics.recordError(args[0]);
          } else if (errorMessage) {
            // Create a non-fatal error for other error types
            crashlytics.recordError(new Error(errorMessage));
          }
        }
      } catch (err) {
        // Don't fail if Crashlytics logging fails
        if (isDevelopment) {
          console.warn('[Logger] Crashlytics logging failed:', err);
        }
      }
    }
  },
  
  warn: (...args) => {
    if (isDevelopment) {
      console.warn(...args);
    }
  },
  
  info: (...args) => {
    if (isDevelopment) {
      console.info(...args);
    }
  }
};
